export const generateFormName = (entity: string, id: number): string => `DELETION_${entity}_${id}`;
